<template>
    <div class="filter-results-display">
        <span class="filter-results-display__message">{{ message }}</span>
        <span class="filter-results-display__short-message">{{ shortMessage }}</span>
        <span v-if="!allMeasuresShown"
              class="filter-results-display__clear-filters">
            <a href="#"
               class="filter-results-display__clear-filters__link"
               @click="$emit('clear')">clear filters</a>
        </span>
    </div>
</template>

<script>

export default {

    props: {
        shown: {
            type: Number,
            required: true,
        },
        total: {
            type: Number,
            required: true,
        },
    },

    computed: {

        allMeasuresShown() {
            return this.shown == this.total
        },

        message() {
            return this.allMeasuresShown
                ? 'Showing all possible measures'
                : this.shown == 0
                    ? 'No measures shown'
                    : `Showing ${ this.shown } of ${ this.total } possible measures`
        },

        shortMessage() {
            return this.shown == 0
                ? 'None shown'
                : this.message.replace(' possible', '')
        },
    },
}

</script>

<style lang="scss">

// Ensure colours and other visual style elements are added to theme files, not placed in here.
// src\scss\schemes\components\plan-builder\_filter-results-display.scss

.filter-results-display {
    font-size: 0.9rem;

    @include element('message') {
        display: none;

        @include bp-min-small {
            display: inline;
        }

        @include bp-min-mid {
            display: none;
        }

        @include bp-min-wide {
            display: inline;
        }
    }

    @include element('short-message') {

        @include bp-min-small {
            display: none;
        }

        @include bp-min-mid {
            display: inline;
        }

        @include bp-min-wide {
            display: none;
        }

    }

    @include element('clear-filters') {

        &:before {
            content: ' ('
        }

        &:after {
            content: ')'
        }
    }
}

</style>
